import {Nav} from "react-bootstrap";
import {Link} from "react-router-dom";
import React from "react";
import SubMenu from "root/Components/Sidebar/SubMenu";

export const EstarMenuItem = ({icon, text, url, defaultActive, subMenus, keyName, target}) =>
{
    const IconClass = icon;

    const urlPlusMenu = url + '?activeMenu=' + keyName ;

    if (subMenus === undefined)
    {
        const localTarget = target !== undefined ? target : null ;

        return (
            <Nav.Item className={defaultActive === true ? "active" : ''} key={'nav-' + keyName }>
                <Link to={urlPlusMenu} className='nav-link' target={localTarget}>
                    <IconClass key={'i'}/>
                    <div className='sidebar-display-text' key='d'>{text}</div>
                </Link>
            </Nav.Item>
        )
    }
    else
    {
        return (
            <SubMenu
                title="Reports"
                icon={icon}
                items={subMenus}
                onClickItem={onClickItem}
            />
        )
    }
}